var _defs, _rect, _g, _path, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGooglePlay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "google-play",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 244.53,
    height: 72.453,
    viewBox: "0 0 244.53 72.453",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.808,
    y1: 0.5,
    x2: -1.573,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffde00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#fabb0e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "#f8a218"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f79a1c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.862,
    y1: 0.178,
    x2: -0.501,
    y2: 1.948,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ed4447"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c4166c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -0.507,
    y1: -0.956,
    x2: 0.606,
    y2: 0.489,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#269d6f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.051,
    stopColor: "#2b9f6e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.466,
    stopColor: "#52b16a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.797,
    stopColor: "#6bbb68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#74c068"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13437",
    "data-name": "Rectangle 13437",
    width: 244.53,
    height: 72.452,
    rx: 8,
    transform: "translate(0 0)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_337",
    "data-name": "Group 337",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_336",
    "data-name": "Group 336"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8444",
    "data-name": "Path 8444",
    d: "M235.474,1.45a7.616,7.616,0,0,1,7.607,7.607V63.4a7.618,7.618,0,0,1-7.607,7.609H9.057A7.618,7.618,0,0,1,1.448,63.4V9.057A7.616,7.616,0,0,1,9.057,1.45H235.474m0-1.45H9.057A9.084,9.084,0,0,0,0,9.057V63.4a9.084,9.084,0,0,0,9.057,9.057H235.474a9.082,9.082,0,0,0,9.055-9.057V9.057A9.082,9.082,0,0,0,235.474,0Z",
    fill: "#a5a4a4"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_8445",
    "data-name": "Path 8445",
    d: "M49.076,8.522a7.593,7.593,0,0,0-7.732,7.7,7.733,7.733,0,0,0,15.465,0A7.593,7.593,0,0,0,49.076,8.522Zm0,12.372a4.457,4.457,0,0,1-4.348-4.669,4.359,4.359,0,1,1,8.7,0A4.456,4.456,0,0,1,49.076,20.894ZM32.207,8.522a7.594,7.594,0,0,0-7.734,7.7,7.734,7.734,0,0,0,15.467,0A7.594,7.594,0,0,0,32.207,8.522Zm0,12.372a4.456,4.456,0,0,1-4.349-4.669,4.359,4.359,0,1,1,8.7,0A4.456,4.456,0,0,1,32.207,20.894ZM12.139,10.885v3.268H19.96a6.81,6.81,0,0,1-1.781,4.114,8,8,0,0,1-6.04,2.392,8.58,8.58,0,0,1-8.578-8.694,8.581,8.581,0,0,1,8.578-8.7A8.329,8.329,0,0,1,18.034,5.6L20.339,3.3a11.4,11.4,0,0,0-8.2-3.3A12.132,12.132,0,0,0,0,11.965,12.131,12.131,0,0,0,12.139,23.93a10.944,10.944,0,0,0,8.346-3.356,10.806,10.806,0,0,0,2.831-7.646,10.6,10.6,0,0,0-.175-2.043Zm82.068,2.54a7.159,7.159,0,0,0-6.6-4.9c-3.968,0-7.265,3.121-7.265,7.7a7.539,7.539,0,0,0,7.646,7.7,7.662,7.662,0,0,0,6.419-3.416l-2.626-1.749a4.4,4.4,0,0,1-3.793,2.129,3.92,3.92,0,0,1-3.735-2.333l10.3-4.261ZM83.7,15.991A4.227,4.227,0,0,1,87.73,11.5a2.984,2.984,0,0,1,2.86,1.634Zm-8.374,7.471h3.385V.817H75.327Zm-5.545-13.22h-.116A5.34,5.34,0,0,0,65.61,8.522a7.711,7.711,0,0,0,0,15.408,5.248,5.248,0,0,0,4.056-1.752h.116v1.11c0,2.946-1.575,4.522-4.115,4.522a4.265,4.265,0,0,1-3.881-2.744L58.84,26.293a7.34,7.34,0,0,0,6.827,4.552c3.969,0,7.326-2.334,7.326-8.025V8.987H69.782ZM65.9,20.894a4.421,4.421,0,0,1-4.29-4.639,4.456,4.456,0,0,1,4.29-4.7c2.306,0,4.115,1.984,4.115,4.7C70.016,18.939,68.207,20.894,65.9,20.894ZM110.064.819h-8.1V23.463h3.379v-8.58h4.72a7.176,7.176,0,0,0,7.429-7.033A7.174,7.174,0,0,0,110.064.819Zm.087,10.913h-4.807V3.97h4.807a3.924,3.924,0,0,1,3.962,3.88A3.945,3.945,0,0,1,110.151,11.731Zm20.889-3.252a6.347,6.347,0,0,0-6.031,3.467l3,1.253a3.2,3.2,0,0,1,3.088-1.662c1.746,0,3.524,1.048,3.553,2.913v.234a7.478,7.478,0,0,0-3.525-.874c-3.234,0-6.525,1.778-6.525,5.1,0,3.029,2.652,4.981,5.624,4.981a4.764,4.764,0,0,0,4.311-2.216h.116v1.749h3.263V14.743C137.914,10.723,134.912,8.479,131.039,8.479Zm-.409,12.41c-1.106,0-2.65-.553-2.65-1.923,0-1.749,1.924-2.418,3.583-2.418a6,6,0,0,1,3.087.758A4.1,4.1,0,0,1,130.63,20.89ZM149.8,8.975l-3.874,9.817h-.117l-4.019-9.817h-3.642l6.03,13.722-3.437,7.631h3.524l9.293-21.353ZM119.357,23.463h3.379V.819h-3.379Z",
    transform: "translate(74.34 30.878)",
    fill: "#fff"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_340",
    "data-name": "Group 340",
    transform: "translate(18.063 12.952)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_339",
    "data-name": "Group 339"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_338",
    "data-name": "Group 338"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8446",
    "data-name": "Path 8446",
    d: "M.837.131A3.627,3.627,0,0,0,0,2.674V42.7a3.629,3.629,0,0,0,.837,2.543l.134.131L23.393,22.951v-.529L.971,0Z",
    transform: "translate(0 0.588)",
    fill: "#5bc7f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8447",
    "data-name": "Path 8447",
    d: "M7.475,15.482,0,8.005V7.477L7.477,0l.167.1L16.5,5.129c2.528,1.437,2.528,3.788,0,5.224L7.644,15.387Z",
    transform: "translate(23.392 15.534)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8448",
    "data-name": "Path 8448",
    d: "M30.2,7.644,22.556,0,0,22.556c.835.883,2.212.991,3.762.111L30.2,7.644",
    transform: "translate(0.838 23.275)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8449",
    "data-name": "Path 8449",
    d: "M30.2,15.63,3.762.609C2.212-.273.835-.163,0,.719L22.556,23.276Z",
    transform: "translate(0.838)",
    fill: "url(#linear-gradient-3)"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_341",
    "data-name": "Group 341",
    transform: "translate(74.876 9.887)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8450",
    "data-name": "Path 8450",
    d: "M0,10.866V0H3.326A5.4,5.4,0,0,1,7.333,1.509a5.324,5.324,0,0,1,1.5,3.924,5.315,5.315,0,0,1-1.5,3.923,5.4,5.4,0,0,1-4.007,1.511ZM1.4,9.532H3.326A4.075,4.075,0,0,0,6.307,8.453a4.034,4.034,0,0,0,1.1-3.021,4.043,4.043,0,0,0-1.1-3.013A4.062,4.062,0,0,0,3.326,1.333H1.4Z",
    transform: "translate(0 2.793)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8451",
    "data-name": "Path 8451",
    d: "M0,10.866V0H1.394V10.866Z",
    transform: "translate(10.793 2.793)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8452",
    "data-name": "Path 8452",
    d: "M3.794,11.354a4.057,4.057,0,0,1-2.315-.773A3.581,3.581,0,0,1,0,8.409l1.275-.515A2.906,2.906,0,0,0,2.206,9.4a2.357,2.357,0,0,0,1.589.615,2.539,2.539,0,0,0,1.555-.477,1.528,1.528,0,0,0,.644-1.3,1.656,1.656,0,0,0-.644-1.4,6.625,6.625,0,0,0-2.041-.921A5.452,5.452,0,0,1,1.122,4.744,2.462,2.462,0,0,1,.377,2.9,2.7,2.7,0,0,1,1.3.866,3.4,3.4,0,0,1,3.717,0,3.492,3.492,0,0,1,5.964.691,3.189,3.189,0,0,1,7.086,2.2l-1.273.53a1.894,1.894,0,0,0-.675-.957,2.127,2.127,0,0,0-1.389-.438,2.138,2.138,0,0,0-1.373.447A1.362,1.362,0,0,0,1.806,2.9,1.265,1.265,0,0,0,2.33,3.925a5.025,5.025,0,0,0,1.541.751,13.464,13.464,0,0,1,1.343.5,6.1,6.1,0,0,1,1.093.646,2.574,2.574,0,0,1,.834,1,3.237,3.237,0,0,1,.281,1.389A2.991,2.991,0,0,1,7.1,9.624a2.64,2.64,0,0,1-.867.987,4.241,4.241,0,0,1-1.16.553A4.327,4.327,0,0,1,3.794,11.354Z",
    transform: "translate(13.951 2.549)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8453",
    "data-name": "Path 8453",
    d: "M1.4,10.866H0V0H3.7a3.44,3.44,0,0,1,2.39.916A3,3,0,0,1,7.1,3.233,3,3,0,0,1,6.095,5.546a3.433,3.433,0,0,1-2.39.918H1.4Zm0-5.737H3.734a1.8,1.8,0,0,0,1.411-.592,1.908,1.908,0,0,0,.532-1.3,1.909,1.909,0,0,0-.532-1.307,1.8,1.8,0,0,0-1.411-.593H1.4Z",
    transform: "translate(23.376 2.793)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8454",
    "data-name": "Path 8454",
    d: "M9.569,9.706a5.329,5.329,0,0,1-3.984,1.647A5.322,5.322,0,0,1,1.6,9.706,5.549,5.549,0,0,1,0,5.677,5.548,5.548,0,0,1,1.6,1.649,5.323,5.323,0,0,1,5.585,0,5.322,5.322,0,0,1,9.562,1.656,5.548,5.548,0,0,1,11.17,5.677,5.556,5.556,0,0,1,9.569,9.706ZM2.632,8.8a4,4,0,0,0,2.953,1.22A4,4,0,0,0,8.537,8.8,4.257,4.257,0,0,0,9.744,5.677,4.255,4.255,0,0,0,8.537,2.557a4,4,0,0,0-2.952-1.22,4,4,0,0,0-2.953,1.22A4.262,4.262,0,0,0,1.426,5.677,4.264,4.264,0,0,0,2.632,8.8Z",
    transform: "translate(31.558 2.549)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8455",
    "data-name": "Path 8455",
    d: "M0,10.866V0H1.7L6.981,8.453h.062L6.981,6.359V0h1.4V10.866H6.923L1.4,2H1.336L1.4,4.1v6.769Z",
    transform: "translate(44.688 2.793)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8456",
    "data-name": "Path 8456",
    d: "M0,13.659V2.793H1.4V13.659ZM1.306,1.943H.09L.881,0H2.4Z",
    transform: "translate(55.556 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8457",
    "data-name": "Path 8457",
    d: "M3.824,10.866,0,0H1.548L4.523,8.818h.061L7.681,0H9.229L5.282,10.866Z",
    transform: "translate(58.303 2.793)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8458",
    "data-name": "Path 8458",
    d: "M6.345,1.333H1.4V4.781H5.859v1.3H1.4V9.532H6.345v1.334H0V0H6.345Z",
    transform: "translate(69.109 2.793)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8459",
    "data-name": "Path 8459",
    d: "M0,10.866V0H1.4V9.532H6.1v1.334Z",
    transform: "translate(77.64 2.793)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8460",
    "data-name": "Path 8460",
    d: "M0,10.866V0H1.7L6.982,8.453h.061L6.982,6.359V0h1.4V10.866H6.921L1.4,2h-.06L1.4,4.1v6.769Z",
    transform: "translate(89.145 2.793)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8461",
    "data-name": "Path 8461",
    d: "M9.57,9.706a5.331,5.331,0,0,1-3.984,1.647A5.324,5.324,0,0,1,1.6,9.706,5.549,5.549,0,0,1,0,5.677,5.548,5.548,0,0,1,1.6,1.649,5.324,5.324,0,0,1,5.585,0,5.322,5.322,0,0,1,9.562,1.656,5.55,5.55,0,0,1,11.17,5.677,5.559,5.559,0,0,1,9.57,9.706ZM2.631,8.8a4,4,0,0,0,2.954,1.22A3.991,3.991,0,0,0,8.537,8.8,4.258,4.258,0,0,0,9.744,5.677,4.257,4.257,0,0,0,8.537,2.557a3.991,3.991,0,0,0-2.952-1.22,4,4,0,0,0-2.954,1.22,4.266,4.266,0,0,0-1.2,3.119A4.268,4.268,0,0,0,2.631,8.8Z",
    transform: "translate(99.332 2.549)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/google-play.6d5b79be090627f9d2aa2f9eb92c512f.svg";
export { ForwardRef as ReactComponent };